<template>
    <div class="accordion-faq wow move-up">
        <b-card no-body>
            <b-card-header header-tag="header">
                <b-button block v-b-toggle.accordion-1 class="faq-title">{{ $t('tamamenduyarli') }}</b-button>
            </b-card-header>
            <b-collapse id="accordion-1" accordion="my-accordion">
                <b-card-body>
                    <b-card-text>
                        İşletmelerin ihtiyaç duydukları tüm iş süreçlerini entegre bir şekilde sağlayan ticari yazılım KARPİN, Üretimden Sevkiyata, Toptan ve Parekende satış kanallarında gerçekleşen satıştan satış sonrası hizmetlere kadar; bir perakendeci, toptancı ya da üretici firmanın gereksinim duyacağı tüm iş süreçlerini baştan sona kapsamaktadır. KARPİN, tüm iş süreçlerinin uçtan uca entegre bir yapıda yürütülmeleri sayesinde hataların önüne geçer, izlenebilirliği ve güvenle karar almayı sağlar, departmanlar arası etkileşimi sağlayarak kurumsal veri bütünlüğünü güçlendirir ve böylelikle firmaların kurumsal gelişim süreçlerini hızlandırır.
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>

        <b-card no-body>
            <b-card-header header-tag="header">
                <b-button block v-b-toggle.accordion-2 class="faq-title">{{ $t('daimaguncel') }}</b-button>
            </b-card-header>
            <b-collapse id="accordion-2" accordion="my-accordion">
                <b-card-body>
                    <b-card-text>
                        İnternet bağlantınızın olduğu her ortamdan ister İOS yüklü iphone ve ipad ten istersenizde Android yüklü cihazlardan veya İnternet Sayfasını kullanarak verilerinize her daim kullanıcı adı şifre ve güvenlik bilgileriyle erişebilirsiniz.
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>

        <b-card no-body>
            <b-card-header header-tag="header">
                <b-button block v-b-toggle.accordion-3 class="faq-title">{{ $t('mukemmelmusteridestegi') }}</b-button>
            </b-card-header>
            <b-collapse id="accordion-3" accordion="my-accordion">
                <b-card-body>
                    <b-card-text>
                        Müşteri Destek departmanı ile, İster Çevrimiçi Online yazışma ile isterseniz iş yerinizde isterseniz de uzaktan bağlantı araçları ile 7/24 destek.
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>

        <b-card no-body>
            <b-card-header header-tag="header">
                <b-button block v-b-toggle.accordion-4 class="faq-title">{{ $t('istegebagliekstrahizmetler') }}</b-button>
            </b-card-header>
            <b-collapse id="accordion-4" accordion="my-accordion">
                <b-card-body>
                    <b-card-text>
                        Form Tasarımları, Modül Yükleme ,Yetkilendirme , Yazıcı Ayarları, Bağlantı Ayarlarınızı istemeniz durumunda ücret karşığı yapıyoruz.
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'Accordion',
    };
</script>